// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__owA0B","amount":"Amount_amount__2DMgj","tip":"Amount_tip__3iu9m","tipHeader":"Amount_tipHeader__2Kn8X","tipsWrap":"Amount_tipsWrap__1gzOD"};